@if (showSpecialEvents) {
    <div class="sp-container">
        @for (eventsGroup of eventsByType; track trackByOrder) {
            <accordion class="outer-accordion" [accordionTitle]="eventsGroup.typeName" [isExpanded]="isExpandedType" data-crlat="outerAccordion">
                <accordion-body>
                    @for (eventEntity of eventsGroup.events; track trackById($index, eventEntity)) {
                        <ng-container data-crlat="race.specialsSection">
                            <accordion
                                [accordionTitle]="eventEntity.originalName"
                                [inner]="true"
                                [isExpanded]="eventEntity.isExpandedEvent"
                                class="sp-inner-header"
                                data-crlat="raceCard.event">
                                <right-side data-crlat="race.specialsSectionEvent">
                                    <span [textContent]="eventEntity.startTimeFiltered" class="competition-date" data-crlat="eventDate"></span>
                                </right-side>
                                <accordion-body>
                                    <div class="container-inner-content">
                                        @if (eventEntity.markets[0].isEachWayAvailable) {
                                            <div class="each-way-container" data-crlat="terms">
                                                <span
                                                    class="odds-small"
                                                    [innerHTML]="formatSpecialTerms(eventEntity.markets[0].terms)"
                                                    data-crlat="eachWayContainer"></span>
                                            </div>
                                        }
                                        @for (outcome of eventEntity.markets[0].filteredOutcomes; track outcomeIndex; let outcomeIndex = $index) {
                                            <div>
                                                @if (outcomeIndex < limit || eventEntity.showAll) {
                                                    <div class="odds-card" data-crlat="outcomeEntity">
                                                        <div class="odds-content">
                                                            <div class="odds-left">
                                                                <div
                                                                    class="odds-names odds-names-wrap"
                                                                    data-crlat="outcomeName"
                                                                    [textContent]="eventEntity.nameOverride ? eventEntity.name : outcome.name"></div>
                                                            </div>
                                                            <div class="odds-right">
                                                                <price-odds-button
                                                                    [event]="eventEntity"
                                                                    [market]="eventEntity.markets[0]"
                                                                    [outcome]="outcome"
                                                                    [gtmModuleTitle]="[eventsGroup.typeName, eventEntity.originalName].join('. ')">
                                                                </price-odds-button>
                                                            </div>
                                                        </div>
                                                        @if (eventEntity.markets[0].isSmartBoosts && outcome.wasPrice) {
                                                            <div class="odds-footer">
                                                                <div class="odds-right">
                                                                    <div class="was-price">
                                                                        <span [i18n]="'sb.wasPrice'"></span>
                                                                        <strike [textContent]="outcome.wasPrice"></strike>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @if (eventEntity.markets[0].outcomes.length > 4) {
                                            <show-all-button
                                                (click)="eventEntity.showAll = !eventEntity.showAll"
                                                [spinnerVisible]="false"
                                                [allShown]="eventEntity.showAll">
                                            </show-all-button>
                                        }
                                    </div>
                                </accordion-body>
                            </accordion>
                        </ng-container>
                    }
                </accordion-body>
            </accordion>
        }
    </div>
}
@if (!showSpecialEvents) {
    <no-events></no-events>
}
